import { PPIA_SALESBOT } from 'pricing-pages-lib/constants/Gates';
import { getI18nLanguage } from 'pricing-pages-ui-components/utils/languageUtils';
import { PPIA_0002_GROUP_PARAMETER_KEY, PPIA_0002_GROUP_PARAMETER_OPTIONS, PPIA_0002_TREATMENT_KEY } from '../../constants/experimentKeys';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { useCurrentNavItem } from '../../hooks/useCurrentNavItem';
import { useIsHubSpotOnCreditsPilot } from '../../hooks/useIsHubSpotOnCreditsPilot';
import { useIsUngated } from '../../v2/hooks/gating/useIsUngated';
import { useIsInAppAuth } from '../../v2/hooks/user/useUserInfo';
import { logExperimentExposure, useExperimentEffect } from './experimentUtils';
export const logPPIA0002Exposure = () => {
  logExperimentExposure(PPIA_0002_TREATMENT_KEY);
};
const usePPIA0002EligibilityCondition = () => {
  const isUngated = useIsUngated(PPIA_SALESBOT);
  const isInAppAuth = useIsInAppAuth();
  const currentNavItem = useCurrentNavItem();
  const {
    isInPilot: isHsocPilot
  } = useIsHubSpotOnCreditsPilot();
  const isEnglish = getI18nLanguage() === 'en';
  const isConditionMet = isUngated && isInAppAuth && currentNavItem !== NavItemEnum.ADD_ONS && currentNavItem !== null && !isHsocPilot && isEnglish;
  return {
    isConditionMet
  };
};
export const usePPIA0002ExperimentEffect = () => {
  const eligibilityCondition = usePPIA0002EligibilityCondition();
  return useExperimentEffect({
    treatmentKey: PPIA_0002_TREATMENT_KEY,
    groupParameterKey: PPIA_0002_GROUP_PARAMETER_KEY,
    groupParameterOptions: PPIA_0002_GROUP_PARAMETER_OPTIONS,
    experimentEligibilityCondition: () => eligibilityCondition,
    shouldLogExposure: false
  });
};